import { IStore } from "..";
import { TFormFilterRequest, TFormFilterReducerState } from "../../app/types/formTypes";

export const getFilters = (state: IStore): Partial<TFormFilterRequest> => state.formFilterReducer.filters;
export const getState = (state: IStore) : TFormFilterReducerState => state.formFilterReducer;
